<template>
  <a-modal v-model="visible" title="快递公司数据对接" @ok="handleOk">
      <a-list
      class="dataconnection-list"
      item-layout="horizontal"
      :data-source="group"
    >
      <a-list-item slot="renderItem" slot-scope="item, index">
        <a-switch
          slot="actions"
          default-checked
          v-model="item.status"
          :disabled="item.disabled"
          :loading="item.loading"
          @change="onChange(item, index)">
          <a-icon slot="checkedChildren" type="check" />
          <a-icon slot="unCheckedChildren" type="close" />
        </a-switch>
        <a-list-item-meta>
          <div slot="description">
            <div v-html="item.desc" class="desc" :class="{open: item.open}"></div>
          </div>
          <a slot="title" @click="openDesc(index, item.open)">{{ item.name }}</a>
          <a-avatar
            slot="avatar"
            :src="item.ico"
          />
        </a-list-item-meta>
        <div class="success" :class="{error: !item.status}">{{ item.message }}</div>
      </a-list-item>
    </a-list>
  </a-modal>
</template>
<script>
import excom from '../../assets/exicons';
import { dataConnectConfig, setdataConnect } from '../../api/station';

export default {
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      id: '',
      group: [
        {
          name: '圆通快递',
          key: 'yuantong',
          ico: excom.yuantong,
          disabled: false,
          desc: `<p>1、支持快件物流查询</br>
                    2、入库即时效顺延，入库当天起至第三天24点前(即入库72小时之内)必须要出库或者通知圆通业务员统一登记问题件</br>
                    3、出库即自动生成签收</br>
                    4、虚假签收投诉可提供入库短信举证(短信包含取件地址和单号/提货码)</p>`,
          open: false,
          status: true,
          message: '',
          loading: false,
        },
        {
          name: '天天苏宁快递',
          key: 'tiantian',
          ico: excom.tiantian,
          disabled: false,
          desc: `<p>1、支持快件物流信息查询</br>
                    2、入库即满足签收考核(客户取走正常出库)</br>
                    3、客户拒收退回的包裹操作退件出库后交接给合作的天天快递业务员</p>`,
          open: false,
          status: true,
          message: '',
          loading: false,
        },
        {
          name: '中通快递',
          key: 'zhongtong',
          ico: excom.zhongtong,
          desc: `<p>1.支持快件物流信息查询</br>
                    2.入库扫描时间作为考核签收率时间</br>
                    3.出库自动生成签收，无需业务员操作签收</br>
                    4.7天之内必须出库</p>`,
          open: false,
          disabled: false,
          status: true,
          message: '',
          loading: false,
        },
        {
          name: '韵达快递',
          key: 'yunda',
          ico: excom.yunda,
          disabled: true,
          desc: `<p>1、支持快件物流信息查询</br>
                    2、入库即满足签收考核(客户取走正常出库)</br>
                    3、客户拒收退回的包裹操作退件出库后交接给合作的韵达业务员或网</p>`,
          open: false,
          status: true,
          message: '',
          loading: false,
        },
        {
          name: '申通快递',
          key: 'shengtong',
          ico: excom.shengtong,
          disabled: true,
          desc: `<p>1、支持快件物流查询；</br>
                    2、入库即满足签收考核(客户取走正常出库)；</br>
                    3、客户拒收退回的包裹操作退件出库后交接给合作的申通业务员或网点(拒收改地址的包裹退件出库可原单退回)</p>`,
          open: false,
          status: true,
          message: '',
          loading: false,
        },
        {
          name: '百世快递',
          key: 'baishi',
          ico: excom.baishi,
          disabled: true,
          desc: `<p>1.支持快件物流信息查询</br>
                    2.入库即满足签收考核</br>
                    3.客户拒收后包裹退给网点可免费申请取消签收</p>`,
          open: false,
          status: true,
          message: '',
          loading: false,
        },
        {
          name: '菜鸟裹裹',
          key: 'cainiao',
          ico: excom.cainiao,
          disabled: false,
          desc: `<p>1.上传取件码至手淘</br>
                    2.上传取件码至菜鸟裹裹</p>`,
          open: false,
          status: true,
          message: '',
          loading: false,
        },
      ],
    };
  },
  created() {},
  methods: {
    async onChange(item, index) {
      this.group[index].loading = true;
      try {
        const res = await this.setConnection(this.id, item.status, item.key);
        this.group[index].status = res.status;
        // this.group[index].disabled = res.disabled;
        this.group[index].message = res.message;
      } catch (e) {
        this.group[index].status = false;
      }
      this.group[index].loading = false;
    },
    handleOk() {},
    show(id) {
      this.id = id;
      this.visible = true;
      this.getConfig();
    },
    openDesc(index, open) {
      this.group.map((item, itemIndex) => {
        if (index === itemIndex) {
          // eslint-disable-next-line no-param-reassign
          item.open = !open;
        } else {
          // eslint-disable-next-line no-param-reassign
          item.open = false;
        }
        return item;
      });
    },
    async getConfig() {
      const { data } = await dataConnectConfig(this.id);
      this.group.map((item) => {
        const { status, desc, disabled } = data[item.key];
        // eslint-disable-next-line no-param-reassign
        item.status = status === 1;
        // eslint-disable-next-line no-param-reassign
        item.message = desc;
        item.disabled = disabled;
        return item;
      });
    },
    async setConnection(id, status, pinyin) {
      const { data } = await setdataConnect({
        id,
        status,
        excom: pinyin,
      });
      return data;
    },
  },
};
</script>
<style lang="less">
.dataconnection-list{
  .ant-list-item-meta-description{
    .desc{
      max-height: 1.8em;
      overflow:hidden;
      transition: all 0.3s;
      &.open{
        max-height: 13em;
      }
    }
  }
  .success{
    color:#4CAF50;
  }
  .error{
    color:red;
  }
}
</style>
